import axios from './custom-axios';
import { urlRailway } from '../constants/endpoint';

export async function getPasswords() {
  try {
    let id = localStorage.getItem('id');
    const response = await axios.get(
      `${ urlRailway }password/search/${ id }`
    );
    return response.data.secrets;
  } catch (error) {
    console.error(error);
  }
}

export async function searchPasswords(value) {
  try {
    let id = localStorage.getItem('id');
    const response = await axios.get(
      `${ urlRailway }password/search/${id}/${value}`
    );
    return response.data.secrets;
  } catch (error) {
    console.error(error);
  }
}

export async function addPassword(name, url, username, secret, notes, color) {
  try {
    let id = localStorage.getItem('id');

    var passwordForm = new FormData();
    passwordForm.append("name", name);
    passwordForm.append("url", url);
    passwordForm.append("username", username);
    passwordForm.append("secret", secret);
    passwordForm.append("notes", notes);
    passwordForm.append("color", color);
    passwordForm.append("userId", id);

    const response = await axios.post(
      `${ urlRailway }password/add`,
      passwordForm,
      {
        "Content-Type": "multipart/form-data",
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
}

export async function updatePassword(
  id,
  name,
  url,
  username,
  secret,
  notes,
  color
) {
  try {
    
    var passwordForm = new FormData();
    passwordForm.append("name", name);
    passwordForm.append("url", url);
    passwordForm.append("username", username);
    passwordForm.append("secret", secret);
    passwordForm.append("notes", notes);
    passwordForm.append("color", color);
    passwordForm.append("passId", id);

    const response = await axios.put(
      `${ urlRailway }password/modify`,
      passwordForm,
      {
        "Content-Type": "multipart/form-data",
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
}

export async function deletePassword(id) {
  try {
    const response = await axios.delete(
      `${ urlRailway }password/delete/${id}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
}

export async function getDecryptedPassword(id) {
  try {
    const response = await axios.get(
      `${ urlRailway }password/decrypt/${id}`
    );
    return response.data.decrypted;
  } catch (error) {
    console.error(error);
  }
}